// extracted by mini-css-extract-plugin
module.exports = {"w1n5e7hb":"w1n5e7hb","g19jnwoh":"g19jnwoh"};